import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CompanyGrid = ({ companies, onEdit, onDelete, onSelect, selectedCompanyId }) => {
  if (companies?.length === 0) {
    return (
      <div className="text-center py-12">
        <Icon name="Building2" size={48} className="mx-auto text-muted-foreground mb-4" />
        <h3 className="text-lg font-semibold text-foreground mb-2">No companies found</h3>
        <p className="text-muted-foreground">Create your first company to get started</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-border">
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Company</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Sector</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Plants</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Users</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Created</th>
            <th className="text-right py-3 px-4 text-sm font-semibold text-foreground">Actions</th>
          </tr>
        </thead>
        <tbody>
          {companies?.map((company) => (
            <tr
              key={company?.id}
              className={`border-b border-border hover:bg-muted/50 transition-colors cursor-pointer ${
                selectedCompanyId === company?.id ? 'bg-primary/5' : ''
              }`}
              onClick={() => onSelect(company)}
            >
              <td className="py-4 px-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                    <Icon name="Building2" size={18} className="text-primary" />
                  </div>
                  <div>
                    <p className="font-medium text-foreground">{company?.name}</p>
                    <p className="text-sm text-muted-foreground">{company?.contactEmail}</p>
                  </div>
                </div>
              </td>
              <td className="py-4 px-4">
                <span className="inline-flex items-center px-2.5 py-1 rounded-lg bg-accent/10 text-accent text-sm font-medium">
                  {company?.sector}
                </span>
              </td>
              <td className="py-4 px-4 text-foreground">{company?.plants?.length || 0}</td>
              <td className="py-4 px-4 text-foreground">{company?.userCount || 0}</td>
              <td className="py-4 px-4 text-muted-foreground text-sm">
                {new Date(company.createdAt)?.toLocaleDateString()}
              </td>
              <td className="py-4 px-4">
                <div className="flex items-center justify-end gap-2">
                  <Button
                    variant="ghost"
                    size="icon"
                    iconName="Edit"
                    onClick={(e) => {
                      e?.stopPropagation();
                      onEdit(company);
                    }}
                  />
                  <Button
                    variant="ghost"
                    size="icon"
                    iconName="Trash2"
                    onClick={(e) => {
                      e?.stopPropagation();
                      onDelete(company?.id);
                    }}
                  />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CompanyGrid;